import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Check2 } from 'blaze-ui/icons/20'
import Styles from '../AiAvatarAnnouncementModal.module.scss'

const BULLETS = [
  'Studio-quality video from a script — generated in minutes, not days.',
  'Consistent, on-brand presenters across every campaign.',
  'Pick from a library of avatars or upload your own.',
  'Added to your organic and paid campaigns automatically.',
]

interface Props {
  photoUrls: string[]
  onContinue: () => void
  onDismiss: () => void
}

export const IntroStep = ({ photoUrls, onContinue, onDismiss }: Props) => (
  <Modal.Root size="md">
    <Modal.Header title="Turn your topics into lifelike avatar videos" onClose={onDismiss} />
    <Modal.Content>
      <div className={Styles.introContent}>
        {photoUrls.length > 0 && (
          <div className={Styles.gallery}>
            {photoUrls.map((url) => (
              <img key={url} src={url} alt="" data-testid="intro-avatar" className={Styles.portrait} />
            ))}
          </div>
        )}
        <ul className={Styles.bullets}>
          {BULLETS.map((bullet) => (
            <li key={bullet}>
              <span className={Styles.check}>
                <Check2 />
              </span>
              <Text>{bullet}</Text>
            </li>
          ))}
        </ul>
      </div>
    </Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Button variant="tertiary" size="lg" onPress={onDismiss}>
          Not Now
        </Button>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Button variant="primary" size="lg" onPress={onContinue}>
          Turn On AI Avatar Videos
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
